const ViewFaq = ({ changeSettingsPage }) => {
  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">View FAQ</h3>
      <p className="accountSettingsToggleDescription">
        Have a question about our software? We answer those here.
      </p>
      <button
        className="accountSettingsButton"
        onClick={() => changeSettingsPage("FAQ")}
      >
        View FAQ
      </button>
    </div>
  );
};

export default ViewFaq;
